import React from "react";
import { FormattedMessage } from "react-intl";
import { Route, Routes } from "react-router-dom";
import { useCommonFunctions } from "../../hooks/useCommonFunctions";
import ApartmentComponent from "../Apartments/Apartments";
import PostComponent from "../Posts/Posts";
import VehicleComponent from "../Vehicles/Vehicles";
import { Container, Typography } from "@mui/material";
import TravelerComponent from "../Travelers/TravelersAbroad";
import { useUser } from "../../contexts/UserContext";

const ModeratorComponent: React.FC = () => {
  const { content, isLoading } = useCommonFunctions();
  const { userId } = useUser();

  return (
    <Container>
      {isLoading && <p>{content}</p>}
      <Typography variant="h2">
        <FormattedMessage id="mod" />
      </Typography>
      {userId && (
        <Routes>
          <Route
            path="apartments"
            element={
              <ApartmentComponent canDelete={true} listingType="long-term" />
            }
          />
          <Route
            path="short-stays"
            element={
              <ApartmentComponent canDelete={true} listingType="short-stays" />
            }
          />
          <Route
            path="rvs"
            element={<VehicleComponent canDelete={true} vehicleType="rv" />}
          />
          <Route
            path="cars"
            element={<VehicleComponent canDelete={true} vehicleType="car" />}
          />
          <Route
            path="travelers"
            element={<TravelerComponent canDelete={true} />}
          />
          <Route
            path="posts"
            element={
              <PostComponent
                isPublic={false}
                canDelete={true}
                showCreateButton={true}
              />
            }
          />
          <Route
            path="/"
            element={
              <PostComponent
                isPublic={false}
                canDelete={true}
                showCreateButton={true}
              />
            }
          />
        </Routes>
      )}
    </Container>
  );
};

export default ModeratorComponent;
